import React from 'react';
import { Container } from 'react-bootstrap';

import FrequentlyAskedQuestions from './FrequentlyAskedQuestions';

const SellTicketsLayout = ({ children }) => (
    <>
        <Container>
            {children}
        </Container>
        <FrequentlyAskedQuestions/>
    </>
);
export default SellTicketsLayout;
